import { styled } from "styled-components";

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 120px;
  height: 22px;

  border-radius: 11px;
  border: none;
  background-color: #565656;

  color: white;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  /* open sans font remember */
`;
